import { AnimatePresence, motion } from 'framer-motion';
import Link from 'next/link';

import useTranslations from '@/hooks/useTranslation';
import routes from '@/statics/routes';
import ContentBankIcon from '@/svgs/bottombar-content-bank.svg';
import ContentBankActiveIcon from '@/svgs/bottombar-content-bank-active.svg';
import HomeIcon from '@/svgs/bottombar-home.svg';
import HomeActiveIcon from '@/svgs/bottombar-home-active.svg';
import LessonsIcon from '@/svgs/bottombar-lessons.svg';
import LessonsActiveIcon from '@/svgs/bottombar-lessons-active.svg';
import ProfileIcon from '@/svgs/bottombar-profile.svg';
import ProfileActiveIcon from '@/svgs/bottombar-profile-active.svg';

type BottomBarItemProps = {
  title: string;
  href: string;
  active: boolean;
  isBottombarRoute: boolean;
};

const BottomBarItem: React.FC<BottomBarItemProps> = ({
  title,
  href,
  active,
  isBottombarRoute,
}) => {
  const { t } = useTranslations('');

  const Icon = {
    [routes.home.url]: {
      inactive: <HomeIcon className="stroke-bottombar" />,
      active: <HomeActiveIcon />,
    },
    [routes.contentBankCategories.url]: {
      inactive: <ContentBankIcon className="stroke-bottombar" />,
      active: <ContentBankActiveIcon />,
    },
    [routes.lessons.url]: {
      inactive: <LessonsIcon className="stroke-bottombar" />,
      active: <LessonsActiveIcon />,
    },
    [routes.profile.url]: {
      inactive: <ProfileIcon className="stroke-bottombar" />,
      active: <ProfileActiveIcon />,
    },
  };

  return (
    <Link
      href={href}
      className="h-full flex flex-1 flex-col items-center justify-center gap-1 text-sm font-medium text-muted-foreground hover:text-primary focus:text-primary"
      prefetch={false}
    >
      <div className="flex flex-1 flex-col items-center justify-center gap-2">
        <AnimatePresence mode="wait">
          {isBottombarRoute && active ? (
            <motion.div
              key="1"
              initial={{ opacity: 0.5 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.4 }}
            >
              {Icon[href as keyof typeof Icon].active}
            </motion.div>
          ) : (
            Icon[href as keyof typeof Icon].inactive
          )}
        </AnimatePresence>
        <p
          className={`transition duration-250 ease-in-out text-xs ${isBottombarRoute && active ? 'text-bottombar-foreground' : 'text-bottombar'}`}
        >
          {t(title)}
        </p>
      </div>
    </Link>
  );
};

export default BottomBarItem;
